import React from 'react'
import StickyMenuTop from '../components/StickyMenuTop'
import StickyMenuBottom from '../components/StickyMenuBottom'
import ProductItem from '../components/ProductItem'
import EmptyProductItem from '../components/EmptyProductItem'

import '../styles/Products.css'
import ApiService from '../services/api'
import DbService from '../services/db'

class Products extends React.Component{

    constructor(props){
        super(props)

        this.apiService = new ApiService()
        this.dbService = new DbService()
        
         // refresh, used to update cart value
         this.state = {
            products: null,
            refresh: true
        }

        this.cartValue = this.dbService.getCartValue()

        this.productRows = null
        // 
        this.collection = 'productDetails'
        this.LOADING_STATE_COUNT = 6
    }

    componentDidMount(){
        // init
        this.dbService.initCache()
        this.dbService.initCart()
        //
        let result = null
        let vendorId = this.props.match.params.id
          
        
        // check for promocode
        // 
        result = this.apiService.getProducts(vendorId)
    
        result.then( (res)=> {
            this.setState({
                products: res.data
            })
        
        }).catch( (err) => {
            console.error(err);
            
        })
    }

    handleClick(product){
        this.dbService.setCache(this.collection, product)
        let productDetailsPage = '/products/' + product.id
        this.props.history.push(productDetailsPage)
    }


    refresh(){
        this.setState({
            refresh: true
        })
    }

    render(){
            
        let products = this.state.products
        if (this.state.products){
            this.productRows = products.map( (value, index) => {
                // check if product exist
                return ( 
                         <ProductItem product={value} key={value.id} 
                                     onClick={ () => this.handleClick(value)} onRefresh={() => this.refresh()}/>
                )
            })

        }

        else {

           let products = new Array(this.LOADING_STATE_COUNT).fill({})

           this.productRows = products.map( (value, index) => {
               return (
                   <EmptyProductItem key={index}/> 
               )
           }) 
        }

        return (
            <div className='Products'>
                <StickyMenuTop value= {this.state.refresh} />
                    <div className='header-Products'>Explore Products</div>
                    <div className='content-Products'>
                        {this.productRows}
                    </div>
                <StickyMenuBottom highlight='home'/>
            </div>
        );
    }
}


export default Products